var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid px-5", attrs: { id: "agents-container" } },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("page-header", {
                attrs: {
                  title: _vm.$t("agents.title"),
                  subtitle: _vm.$t("agents.subtitle"),
                  size: "col-10",
                  "container-class": "mb-4",
                },
                scopedSlots: _vm._u([
                  {
                    key: "inlinebuttons",
                    fn: function () {
                      return [
                        _c(
                          "b-col",
                          { staticClass: "d-flex flex-column align-items-end" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "bold d-lg-inline d-none",
                                attrs: { size: "sm", variant: "primary" },
                                on: { click: _vm.showAddAgentModal },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("agents.addAgent")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropleft d-lg-none" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "grey-text text-darken-4 clickable d-xl-none",
                                  attrs: { "data-toggle": "dropdown" },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("more_vert"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-menu" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-item clickable wide px-4",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "sm", variant: "white" },
                                        on: { click: _vm.showAddAgentModal },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("agents.addAgent")) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c("agents-table"),
              _vm._v(" "),
              _c("add-agent-modal", { ref: "addAgent" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }